<template>	
	<div class="order-notice">
		<!-- 个人信息-通知详情弹窗页面 -->
		<b-modal id="orderNoticetableTab.orderNoticeModel"
		    v-model="orderNoticetableTab.orderNoticeModel.show"
		   title="通知"
		    no-close-on-backdrop class="order-notice-modal">
			<div>
				<h4 class="title">{{orderNoticetableTab.orderNoticeModel.title}}</h4>
				<p class="time">{{orderNoticetableTab.orderNoticeModel.createTime}}</p>
				<p class="content" v-html="orderNoticetableTab.orderNoticeModel.content"></p>
			</div>
		<template slot="modal-footer">
		    <b-button style="display: none;border-bottom: none;border-top: none;">
		    </b-button>
		</template>	
		</b-modal>
		<!-- 个人信息-通知列表 -->
		<b-spinner variant="success"
		    class="spinStyle"
		    v-show="showSpin"
		    label="Text Centered"></b-spinner>
			<b-table id="order-notice-table"
			    :fields="orderNoticetableTab.orderNoticeFields"
			    :items="orderNoticetableTab.NoticeList"
			    small
			    bordered
			    hover
			    show-empty
			    empty-text="没有找到匹配的记录"
			    caption-top
			    :busy="orderNoticetableTab.isTableBusy">
				<template v-slot:cell(actionButton)="row">
				    <a href="#"
				        v-on:click="showOrderNotice(row)">查看详情</a>
				</template>
			</b-table>	
		<!-- 页码 -->	
		<!-- <div class="pageControl">
		    <b-pagination v-model="orderNoticetableTab.orderNoticeSearch.limit.conditions.pageStart"
		        style="margin-top:20px;"
				:total-rows="orderNoticetableTab.orderNoticeSearch.limit.conditions.total"
		        :per-page="orderNoticetableTab.orderNoticeSearch.limit.conditions.pageLength"
		        align="center"
		        size="sm"
		        ellipsis-text="..."
		        first-text="首页"
		        prev-text="上一页"
		        next-text="下一页"
		        last-text="尾页"
		        limit="10"
		        @change="onOrderNoticePageChange"></b-pagination>
		</div>				 -->
	</div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import HttpRequest from '@/libs/axios';
import { formatDateTimeString, numberToFixed } from "@/libs/utils";
export default {
	name:'OrderNotice',
	data(){
		return{
			showSpin:false,
			orderNoticetableTab:{
				orderNoticeFields:[
					{ key: 'title', label: '标题' },
					{ key: 'content', label: '内容',},
					{ key: 'createTime', label: '发布时间',},
					{ key: 'actionButton', label: '操作' }
				],
				NoticeList:[],
                orderNoticeModel: {
                    show: false,
                    title: '',
                    content: '',
                    createTime: ''
                },
				isTableBusy: false,
				orderNoticeSearch: search.getSearchParams(),
			}
		}
	},
	mounted(){
		this.getOrderNotice();
	},
	methods:{
		// 获取通知详情数据
		showOrderNotice(row) {
		    Object.assign(this.orderNoticetableTab.orderNoticeModel, row.item);
		    this.orderNoticetableTab.orderNoticeModel.title = row.item.title;
		    this.orderNoticetableTab.orderNoticeModel.content = row.item.content;
		    this.orderNoticetableTab.orderNoticeModel.createTime = row.item.createTime;

		    this.orderNoticetableTab.orderNoticeModel.show = true;
		},
		// 引用页面组件发布时间方法
		formatDateTimeString,
		// 获取通知列表数据
		getOrderNotice() {
			api.getOrderNotice({msgType:'通知'}).then(res => {
				if (res.code === 0) {
					if (res.data != null && res.data != '') {
						res.data.forEach(e=>{
							e.createTime=this.formatDateTimeString(e.createTime);
						});
						this.orderNoticetableTab.NoticeList = res.data;
					}
				}
			});
		},
		// 页码
		// onOrderNoticePageChange(pageNum){
		// 	search.globalPageOnChange(this.orderNoticetableTab.orderNoticeSearch, pageNum);
		// 	this.getNoticeList();
		// }
	}
}
</script>

<style>
.page-item.active .page-link{background-color: #1da25a;border: 1px solid #1da25a;}
.modal-header{background-color: #1da25a;color: #fff;}
  .content{margin-top: 0px !important;display: contents;}
</style>



// WEBPACK FOOTER //
// src/view/member/order-notice.vue